export const ROUTES = {
  HOME: '/',
  USERS: '/users',
  USER_DETAILS: '/users/:id',
  ALLOCATIONS: '/allocations',
  ALLOCATIONS_MANAGE: '/allocations/manage/:id',
  BUDGETS: '/budgets',
  BUDGETS_MANAGE: '/budgets/manage/:id',
  DISTRIBUTORS: '/distributors',
  DISTRIBUTORS_MANAGE: '/distributors/manage/:id',
  AUDIT: '/audit',
  IMPORT_DISTRIBUTOR_GROUP_RELATIONSHIPS: '/import/distributor-group-relationships',
  IMPORT_ALLOCATION_GROUP_RELATIONSHIPS: '/import/allocation-group-relationships',
  IMPORT_BUDGET_GROUP_RELATIONSHIPS: '/import/budget-group-relationships',
  ADMIN_ORGANIZATION: '/admin/organizations',
  ADMIN_ORGANIZATION_ADD: '/admin/organizations/add',
  ADMIN_ORGANIZATION_DETAILS: '/admin/organizations/:id',
  LOGIN_CALLBACK: '/login/callback',
} as const;
